import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import Loader from 'Pods/Shared/Loader'
import NumeralHourFormat from 'Utils/NumeralHourFormat'

import ReputationLevelTooltip from './Reputation/ReputationLevelTooltip'
import Reputation from './Reputation/Reputation'

function ReputationContainer({ isDataFetched, data = {
  level: '',
  reputation: 0,
} }) {
  return (
    <div className="card card--flat">
      <div className="dashboard-card dashboard-card--stats">
        <h3>
          <a href="/reputation">Reputation</a> <Tooltip
            tooltipClassName="tooltip--medium"
            id="dashboard__stats-reputation-info"
            content="Your performance and rank among fellow 3D designers. Higher reputation leads to higher Earnings Rate."
          >
            <Icon type={['far', 'question-circle']} color="grey" notSpaced />
          </Tooltip>
          {(isDataFetched && data.length !== 0 && data.next_level !== null)
          && (
          <div className="stats-levels__header">
            Level: <span className="stats-levels__level">
              <Tooltip
                tooltipClassName="tooltip--level-tooltip"
                className="tooltip--level-info"
                id="dashboard__stats-levels-info"
                delayHide={300}
                content={<ReputationLevelTooltip reputation={data.reputation} nextLevel={data.next_level_score} />}
              >
                {data.level}
              </Tooltip>
            </span>
            {data.level.length > 8 && <div className="fade-overlay" />}
          </div>
          )}
        </h3>
        {!isDataFetched ? (
          <Loader />
        ) : (
          data.length === 0 ? (
            <div className="empty-content u-text-center">
              <p>
                Ooops! Something went wrong
              </p>
            </div>
          ) : (
            <Reputation data={data} />
          ))}
      </div>
    </div>
  )
}

ReputationContainer.propTypes = {
  isDataFetched: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    level: PropTypes.string,
    reputation: PropTypes.number,
    next_level: PropTypes.string,
    next_level_score: PropTypes.number,
  }).isRequired,
}

export default ReputationContainer
